import React from 'react';
import styles from './Tab.module.scss';
import clsx from 'clsx';

type OwnProps = {
  text: string;
  isSelected: boolean;
  onClickHandler?: () => void;
};

export const Tab = (props: OwnProps) => {
  return (
    <div
      className={clsx(styles.container, props.isSelected && styles.selected)}
      onClick={props.onClickHandler}
    >
      {props.text}
    </div>
  );
};
